class UiPopover extends HTMLElement {
  constructor() {
    super();
    this.handleMediaChange = this.handleMediaChange.bind(this);
    this.mediaQuery = window.matchMedia('(pointer: coarse), (max-width: 768px)');
  }

  connectedCallback() {
    this.trigger = this.querySelector('.popover-text');
    this.root = this;

    // Set up ARIA attributes
    this.trigger.setAttribute('aria-haspopup', 'true');
    this.trigger.setAttribute('aria-expanded', 'false');
    this.trigger.setAttribute('aria-describedby', this.trigger.id || this.generateId());
    this.trigger.setAttribute('id', this.trigger.id || this.generateId());

    // Initial mode
    this.updateMode(this.mediaQuery.matches);

    // Listen for changes in media query
    this.mediaQuery.addEventListener('change', this.handleMediaChange);
  }

  generateId() {
    return 'popover-' + Math.random().toString(36).substr(2, 9);
  }

  disconnectedCallback() {
    this.mediaQuery.removeEventListener('change', this.handleMediaChange);
  }

  handleMediaChange(e) {
    this.updateMode(e.matches);
  }

  updateMode(isTap) {
    // Clean up any old mode
    this.root.classList.remove('using-tap', 'using-hover');
    this.root.classList.remove('show-popover');

    if (this.tapHandler) {
      this.trigger.removeEventListener('click', this.tapHandler);
      document.removeEventListener('click', this.docClickHandler);
    }

    // Set new mode
    if (isTap) {
      this.root.classList.add('using-tap');

      this.tapHandler = (e) => {
        e.stopPropagation();
        const isOpen = this.root.classList.contains('show-popover');
        this.root.classList.toggle('show-popover');
        this.trigger.setAttribute('aria-expanded', (!isOpen).toString());
      };
      this.docClickHandler = (e) => {
        if (!this.contains(e.target)) {
          this.root.classList.remove('show-popover');
          this.trigger.setAttribute('aria-expanded', 'false');
        }
      };

      this.trigger.addEventListener('click', this.tapHandler);
      document.addEventListener('click', this.docClickHandler);
    } else {
      this.root.classList.add('using-hover');
    }
  }
}

customElements.define('ui-popover', UiPopover);
